import { i18n } from "@/plugins/i18n";

export default [
  {
    field: "id",
    title: "#",
    sortable: true,
    width: 70,
    type: "number",
    selector: false, //{class: 'kt-checkbox--solid'},
    textAlign: "center",
  },

  {
    field: "subject",
    title: i18n.t("label.subject"),
    sortable: true,
  },

  {
    field: "newscontent",
    title: i18n.t("label.newscontent"),
    sortable: true,
  },
];
